import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "w-50 question-rule-label" }
const _hoisted_2 = { class: "w-50 position-relative" }
const _hoisted_3 = { class: "position-relative" }
const _hoisted_4 = { class: "remove-rule-svg-wrapper" }
const _hoisted_5 = { class: "d-flex justify-content-center" }
const _hoisted_6 = { class: "d-flex flex-row-reverse" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rule_multiple_select = _resolveComponent("rule-multiple-select")!
  const _component_close_svg = _resolveComponent("close-svg")!
  const _component_gray_text = _resolveComponent("gray-text")!
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentQuestion.answer_values, (answerValue, id) => {
        return (_openBlock(), _createElementBlock("div", {
          key: answerValue,
          class: "d-flex"
        }, [
          _createElementVNode("div", _hoisted_1, _toDisplayString(answerValue), 1),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_rule_multiple_select, {
                answerValueId: id as string,
                options: _ctx.selectRuleAvailableOptions(_ctx.getRuleValueByAnswerValue(id as string)),
                onOnUpdate: _ctx.onRuleSelected,
                rules: _ctx.currentQuestion.rules
              }, null, 8, ["answerValueId", "options", "onOnUpdate", "rules"]),
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_close_svg, {
                  onClick: ($event: any) => (_ctx.removeRule(id as string))
                }, null, 8, ["onClick"])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_gray_text, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Choose question to be hidden", -1)
        ]))]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_base_button, { onClick: _ctx.handleRuleSave }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", null, "Save", -1)
        ]))]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_base_button, {
        class: "mr-10",
        onHandleClick: _ctx.handleRuleCancel
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
          _createElementVNode("span", null, "Cancel", -1)
        ]))]),
        _: 1
      }, 8, ["onHandleClick"])
    ])
  ]))
}